import React from "react";
import { Input } from "antd";
import trim from "lodash/trim";
import classNames from "classnames";
import WeaTools from "../../wea-tools";
import isRegExp from "lodash/isRegExp";
import isString from "lodash/isString";
import isEmpty from "lodash/isEmpty";
import isFunction from "lodash/isFunction";
import WeaHelpfulTip from "../../wea-helpful-tip";
import WeaLocaleProvider from "../../wea-locale-provider";

const { getLabel, formatMultiLang } = WeaLocaleProvider;
const pClasses = [
  "isWeak",
  "isWeak",
  "isWeak",
  "isWeak",
  "isMiddle",
  "isMiddle",
  "isMiddle",
  "isStrong",
  "isStrong",
  "isStrong",
  "isStrong"
];
const tipsCon = {
  getTips: () => {
    return [
      getLabel(27310, "弱"),
      getLabel(27310, "弱"),
      getLabel(27310, "弱"),
      getLabel(27310, "弱"),
      getLabel(22987, "中"),
      getLabel(22987, "中"),
      getLabel(22987, "中"),
      getLabel(27309, "强"),
      getLabel(27309, "强"),
      getLabel(27309, "强"),
      getLabel(27309, "强")
    ];
  }
};
// const tips = ['弱','弱','弱','弱','中','中','中','强','强','强','强']
function getPasswordStrength(v) {
  var n = 0;
  if (v.match(/\d/)) n += 10;
  if (v.length > 5) n += 20;
  if (v.match(/[a-z]+/)) n += 20;
  if (v.match(/[A-Z]+/)) n += 20;
  if (v.match(/[^\da-zA-Z]/)) n += 30;
  return n;
}

function getPasswordStrengthCT(v, isTip = false) {
  if (v) {
    let t = getPasswordStrength(v) / 10;
    const tips = tipsCon.getTips();
    if (isTip) return tips[t];
    return pClasses[t];
  }
}

class Main extends React.Component {
  static defaultProps = {
    type: "text",
    passwordStrength: false
  };
  constructor(props) {
    super(props);
    this.state = {
      value: props.defaultValue || props.value
    };
    this.needFocus = false;
  }
  componentWillReceiveProps(nextProps) {
    if ("value" in nextProps && this.state.value !== nextProps.value) {
      this.setState({
        value: nextProps.value
      });
    }
    if (this.props.defaultValue !== nextProps.defaultValue) {
      this.setState({
        value: nextProps.defaultValue
      });
    }
  }
  getValue() {
    return trim(this.state.value);
  }
  setValue(v = "") {
    let { value } = this.state;
    const dom = this.refs.input.refs.input;
    dom.focus();
    value =
      dom.value.substr(0, dom.selectionStart) +
      v +
      dom.value.substring(dom.selectionStart, dom.value.length);
    this.setState({ value }, () => dom.focus());
    isFunction(this.props.onChange) && this.props.onChange(value);
  }
  setText = e => {
    const { props } = this;
    e.preventDefault();
    e.stopPropagation();
    let value = e.target.value;
    if (props.length && value.length > props.length) {
      value = value.substring(0, props.length);
    }
    if (
      props.stringLength &&
      WeaTools.getStringLength(value) > props.stringLength
    ) {
      value = WeaTools.getStringByLength(value, props.stringLength);
    }
    if (!isEmpty(value) && props.regExp) {
      let regExp = "";
      if (isRegExp(props.regExp)) regExp = props.regExp;
      if (isString(props.regExp)) regExp = new RegExp(props.regExp);
      if (regExp && !regExp.test(value)) {
        value = this.state.value || "";
      }
    }
    this.setState({
      value
    });
    isFunction(this.props.onChange) && this.props.onChange(value);
  };
  onClick = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onClick && this.props.onClick(e.target.value);
    if (value && (!!window.ActiveXObject || "ActiveXObject" in window)) {
      // 处理ie下右键粘贴到文本框没有触发onchange问题
      isFunction(this.props.onChange) && this.props.onChange(value);
    }
  };
  onBlur = e => {
    const { props } = this;
    e.preventDefault();
    e.stopPropagation();
    let value = e.target.value;
    if (props.filter) {
      value = props.filter(value);
      if (e.target.value !== value) {
        this.setState({ value }, () => {
          isFunction(props.onChange) && props.onChange(value);
        });
      }
    }
    props.onBlur && props.onBlur(value);
    // 多语言模式下内部使用的 customBlur不需要再次触发, 在多语言中已经触发 modeSource={"weaInputLocale"}
    if (props.modeSource !== "weaInputLocale") {
      typeof props.customBlur === "function" &&
        props.customBlur(value.toString());
    }
  };
  onFocus = e => {
    const input = e.target;
    if (this.props.onBeforeFocusCheck) {
      if (!this.needFocus) {
        input.blur();
        this.needFocus = true;
      }
      let cb = () => {
        if (this.needFocus) {
          input.focus();
          this.needFocus = false;
        }
        this.onFocusInner(input);
      };
      this.props.onBeforeFocusCheck(cb, () => {
        input.blur();
      });
    } else {
      this.onFocusInner(input);
    }
  };
  onFocusInner = input => {
    // 火狐下阻止事件会导致光标丢失
    // e.preventDefault();
    // e.stopPropagation();
    // 处理ie下光标出现在文本最前面
    const selectionStart = input.value.length;
    const selectionEnd = input.value.length;
    if (input.setSelectionRange) {
      input.focus();
      input.setSelectionRange(selectionStart, selectionEnd);
    } else if (input.createTextRange) {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveEnd("character", selectionEnd);
      range.moveStart("character", selectionStart);
      range.select();
    }
    this.props.onFocus && this.props.onFocus(input.value);
  };
  onKeyDown = e => {
    const { onKeyDown } = this.props;
    typeof onKeyDown === "function" && onKeyDown(e);
    if (e.keyCode == 13) {
      const { onEnter, onEnterSearch } = this.props;
      const value = e.target.value;
      typeof onEnterSearch === "function" && onEnterSearch(value); // 高级搜索传参
      typeof onEnter === "function" && onEnter(value);
    }
  };
  render() {
    const { value } = this.state;
    const { className, style, viewAttr, ...resProps } = this.props;
    const {
      fieldname,
      hasBorder,
      underline,
      tip,
      passwordStrength,
      textDecoration,
      helpfulTip,
      helpfulTipProps
    } = resProps;
    // let theProps = cloneDeep(this.props);
    // delete theProps.style;
    // theProps.value = value;
    let eles;
    const req = classNames({
      required: (viewAttr === 3 || viewAttr === "3") && trim(value).length === 0
    });
    const readonly = classNames({
      border: hasBorder,
      underline: underline
    });
    if (viewAttr == "1") {
      return (
        <div
          className={`wea-field-readonly ${readonly} ${this.props.className ||
            ""}`}
          style={style}
        >
          <span
            className="child-item wdb"
            dangerouslySetInnerHTML={{ __html: formatMultiLang(value) }}
          />
          {helpfulTip && (
            <WeaHelpfulTip
              ecId={`${this.props.ecId}-WeaHelpfulTip0lapq6`}
              style={{ position: "absolute", right: -31, top: 4 }}
              title={helpfulTip}
              {...helpfulTipProps}
            />
          )}
        </div>
      );
    } else {
      eles = (
        <Input
          {...resProps}
          ecId={`${this.props.ecId}_Input@y16ozl`}
          autocomplete="off"
          ref="input"
          className={`${textDecoration ? "text-decoration" : ""}`}
          value={value}
          onChange={this.setText}
          onClick={this.onClick}
          onBlur={this.onBlur}
          onFocus={this.onFocus}
          onKeyDown={this.onKeyDown}
        />
      );
    }
    return (
      <div
        className={`wea-input-normal ${req} ${this.props.className || ""}`}
        style={style}
        ref="inputNormal"
      >
        {eles}
        {tip && (
          <div
            className="input-tip"
            style={{ marginLeft: 14 }}
            dangerouslySetInnerHTML={{ __html: tip }}
          />
        )}
        {passwordStrength && value && (
          <div className="password-strength-wrap">
            <span
              className={`password-strength ${getPasswordStrengthCT(value)}`}
            />
            {getPasswordStrengthCT(value, true)}
          </div>
        )}
        {helpfulTip && (
          <WeaHelpfulTip
            ecId={`${this.props.ecId}_WeaHelpfulTip@q3wv5q`}
            style={{ position: "absolute", right: -31, top: 4 }}
            title={helpfulTip}
            {...helpfulTipProps}
          />
        )}
        <input type="hidden" id={fieldname} name={fieldname} value={value} />
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-input-normal/index.js